import type { TablerIcon } from "@tabler/icons-react";

export enum Group {
  TopLevel = "top_level",
  Manager = "manager",
  ManagerSite = "manager_site",
  ModuleChoice = "module_choice",
  PvSimulation = "pv_simulation",
  Hidden = "hidden"
}

export interface MenuItemData {
  label: string;
  icon: TablerIcon;
  group: Group;
  showGroups: Array<Group>;
  activeUrlNames?: Array<string>;
  staff?: boolean;
  url?: string;
  persistGroups?: boolean;
}
